<template>
  <div id="application_invoice_outer">
    <div>

      <div class="invoice-item">
        <div>发票类型：</div>
        <div>
          <el-radio v-model="invoiceItem.invoiceValue" :label="1">无需发票</el-radio>
          <el-radio v-model="invoiceItem.invoiceValue" :label="2" >纸质发票</el-radio>
        </div>
      </div>

      <div v-if="invoiceItem.invoiceValue != 1" class="invoice-item">
        <div>抬头类型：</div>
        <div>
          <el-radio v-model="invoiceItem.invoiceTitleValue" :label="1" >企业单位</el-radio>
          <el-radio v-model="invoiceItem.invoiceTitleValue" :label="2">个人/非企业单位</el-radio>
        </div>
      </div>

      <div v-if="invoiceItem.invoiceValue != 1" class="invoice-item">
        <div style="align-self: center;">发票抬头：</div>
        <div>
          <el-input v-model="invoiceItem.invoiceTitle" :placeholder="invoiceItem.invoiceTitleValue == 2 ? '请填入开票人姓名'  : '请填入开票企业名称'" />
        </div>
      </div>

      <div v-if="invoiceItem.invoiceValue != 1 && invoiceItem.invoiceTitleValue != 2" class="invoice-item">
        <div style="align-self: center;" >纳税人识别号：</div>
        <div>
          <el-input v-model="invoiceItem.invoiceNO" placeholder="请填写纳税人识别号" />
        </div>
      </div>

      <div v-if="invoiceItem.invoiceValue != 1" class="invoice-item">
        <div style="align-self: center;" >发票内容：</div>
        <div>
          <el-radio v-model="invoiceItem.invoiceContent" :label="1" >会员服务费</el-radio>
        </div>
      </div>

      <div v-if="invoiceItem.invoiceValue != 1" class="invoice-item">
        <div style="align-self: center;">收件人：</div>
        <div>
          <el-input v-model="invoiceItem.contacts" placeholder="请填写收件人姓名" />
        </div>
      </div>

      <div v-if="invoiceItem.invoiceValue != 1" class="invoice-item">
        <div style="align-self: center;">电话：</div>
        <div>
          <el-input v-model="invoiceItem.tel" placeholder="请填写收件人电话" />
        </div>
      </div>

      <div v-if="invoiceItem.invoiceValue != 1" class="invoice-item">
        <div style="align-self: center;">收件人：</div>
        <div>
          <el-input v-model="invoiceItem.address" placeholder="请填写收件人地址" />
        </div>
      </div>

      <div class="invoice-item" style="margin-top: 50px;">
        <div style="align-self: center;"></div>
        <div >
          <el-button id="invoice_submit" round @click="submitButtonClicked">{{ invoiceItem.invoiceValue == 1 ? '完成' : '提交' }}</el-button>
        </div>
      </div>

    </div>

    <div id="application_success_fixed" v-if="showSuccess">
      <div style="padding: 10px;">
        <span v-if="invoiceItem == 1">恭喜您成为上海市篮球协会会员！</span>
        <span v-else>您的发票申请已提交，我们将尽快和您电话联系确认！</span>
        <span>{{secondValue}}s后将自动跳转至<a href="javascript:void(null);" @click="reloadPage">会员专属页</a></span>
      </div>
    </div>

  </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
  name: "ApplicationInvoice",
  data() {
    return {
      title: '开票信息',

      invoiceItem: {
        invoiceValue: 1,
        invoiceTitleValue: 1,
        invoiceTitle: '',
        invoiceNO: '',
        invoiceContent: 1,
        contacts: '',
        tel: '',
        address: ''
      },
      showSuccess: false,
      secondValue: 0,
      timerFlag: null,
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    user() {
      return this.$store.state.user;
    },
  },

  methods: {
    submitButtonClicked() {

      let params = {};
      let invoiceItem = this.invoiceItem;
      let invoiceValue = invoiceItem.invoiceValue;
      let userId = this.user.id;
      params.userId = userId;
      params.orderId = 0;
      if (invoiceValue == 1) {
        params.id = -1;
        this.postInvoiceData(params);
        return;
      }

      params.id = 0;

      let invoiceTitle = invoiceItem.invoiceTitle.removeBlanks();
      if (invoiceTitle == '') {
        this.$toast('请输入发票抬头！');
        return;
      }
      params.title = invoiceTitle;

      let invoiceTitleValue = invoiceItem.invoiceTitleValue;
      params.type = invoiceTitleValue;
      if (invoiceTitleValue == 1) {
        let invoiceNO = invoiceItem.invoiceNO.removeBlanks();
        if (invoiceNO == '') {
          this.$toast('请输入纳税人识别号！');
          return;
        }
        params.taxNumber = invoiceNO;
      }

      let contacts = invoiceItem.contacts.removeBlanks();
      if (contacts == '') {
        this.$toast('请输入收件人姓名！');
        return;
      }
      params.addressee = contacts;

      let tel = invoiceItem.tel.removeBlanks();
      if (tel == '') {
        this.$toast('请输入收件人电话！');
        return;
      }
      params.tel = tel;

      let address = invoiceItem.address.removeBlanks();
      if (address == '') {
        this.$toast('请输入收件人地址！');
        return;
      }
      params.address = address;

      this.postInvoiceData(params);

    },

    postInvoiceData(params) {
      let loadFlags = Loading.service({
        target: document.getElementById('app'),
        fullscreen: true
      });

      let _this = this;
      this.httpManager.ajax.postUcTaxRequest(params, function (data) {
        loadFlags.close();
        let code = data.code;
        if (code == 0) {
          _this.dealWithSuccessDiv();
          return;
        } else if (code == 2) {
          _this.$toast('发票只能申请一次，不能重复申请！');
          return;
        }
        _this.$toast('提交失败！');

      }, function (data) {
        loadFlags.close();
        _this.$toast('提交失败，请重试！');
      });
    },

    dealWithSuccessDiv() {
      if (this.showSuccess) {
        return;
      }

      this.secondValue = 3;
      this.showSuccess = true;
      let _this = this;
      this.timerFlag = setInterval(function () {
        _this.secondValue --;
        if (_this.secondValue == 0) {
          _this.reloadPage();
        }
      },1000);
    },
    closeTimer() {
      if (this.timerFlag != null) {
        clearInterval(this.timerFlag);
        this.timerFlag = null;
      }
    },
    reloadPage() {
      this.closeTimer();
      this.$router.go(0);
    }
  }
}
</script>

<style scoped>
  #application_invoice_outer {
    padding: 15px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  #application_invoice_outer > div {
    width: 95%;
    padding: 5px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #application_invoice_outer .invoice-item {
    width: 100%;
    max-width: 700px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 20px;
  }

  #application_invoice_outer .el-input {
    max-width: 400px;
  }

  #application_invoice_outer /deep/ .el-input__inner:focus {
    border: solid 1px #fc1a34;
  }

  #application_invoice_outer .invoice-item > div:first-child {
    width: 40%;
    text-align: right;
  }

  #application_invoice_outer .invoice-item > div:last-child {
    width: 55%;
    margin-left: 5%;
  }

  @media screen and (min-width: 768px){
    #application_invoice_outer .invoice-item > div:first-child {
      width: 30%;
      text-align: right;
    }

    #application_invoice_outer .invoice-item > div:last-child {
      width: 60%;
      margin-left: 5%;
    }
  }

  #application_invoice_outer  /deep/ .el-radio .el-radio__input .el-radio__inner:hover {
    border-color: #fc1a34;
  }

  #application_invoice_outer  /deep/ .el-radio.is-checked .el-radio__input .el-radio__inner {
      border-color: #fc1a34;
      background-color: #fc1a34;
   }
  #application_invoice_outer  /deep/ .el-radio.is-checked .el-radio__label {
    color: #fc1a34;
  }

  #invoice_submit {
    background-color: #fc1a34;
    border-color: #fc1a34;
    color: white;
    width: 100%;
    max-width: 300px;
  }

  #invoice_submit:hover {
    color: #eee;
  }

  #application_success_fixed {
    background-color: rgba(0,0,0,0.3);
    width: 100vw;
    height: 100vh;
    z-index: 999;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
  }

  #application_success_fixed > div {
    background-color: white;
    width: 90%;
    height: 90%;
    max-width: 700px;
    max-height: 300px;
    font-size: 1.5rem;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  #application_success_fixed > div span:last-child {
    margin-top: 30px;
  }

  #application_success_fixed > div span:last-child > a {
    color: #fc1a34;
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/personApplicationVues/ApplicationInvoice.vue